import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';

interface IProps {
  className?: string;
  children?: ReactNode;
}

export const FilterContent = observer(
  (props: IProps): ReactElement => <div className={classNames('image-filter-content', props.className)}>{props.children}</div>
);
